import { combineReducers } from 'redux';

import { usuarioReducer } from './usuarioReducer';
import { clienteReducer } from "./clienteReducer";
import { carritoReducer } from './carritoReducer';
import { opReducer } from './opReducer';
import { abonoReducer } from './abonoReducer';
import { trasabilidadReducer } from './trasabilidadReducer';
import { modalReducer } from './modalReducer';
import { deudaClienteReducer } from './deudaClienteReducer';
import { servicioReducer } from './servicioReducer';
import { gastoReducer } from './gastosReducer';
import { ivaReducer } from './ivaReducer';
import { inventarioReducer } from './inventarioReducer';
import { abonoFacturaReducer } from './abonoFacturaReducer';
import { reportesInventarioReducer } from './reportesinventario';
import { pagoInventarioReducer } from './pagosInventarioReducer';





export const rootReducer = combineReducers({
    abono: abonoReducer,
    abonoFactura: abonoFacturaReducer,
    carrito: carritoReducer,
    cliente: clienteReducer,
    deudaCliente: deudaClienteReducer,
    gastos: gastoReducer,
    inventario: inventarioReducer,
    iva: ivaReducer,
    modal: modalReducer,
    op: opReducer,
    pagoinv: pagoInventarioReducer,
    reporteinventario: reportesInventarioReducer,
    servicio: servicioReducer,
    trasabilidad: trasabilidadReducer,
    user: usuarioReducer,
});